/** @format */

import React from 'react';

/**
 * Simple sort component for handing table header sort html
 */
const Sort = function Sort(props) {
    const handleClick = () => {
        var direction;
        if (props.sort_field == props.sort) {
            direction = props.direction == 'asc' ? 'desc' : 'asc';
        } else {
            direction = props.default_direction;
        }
        if (typeof props.onSort === 'function') {
            props.onSort(props.sort_field, direction);
        }
    };

    /**
     * Get the asc or desc icons
     * @returns {XML}
     * @private
     */
    const _sortingIcon = () => {
        if (props.direction == 'asc') {
            return <i className="fa fa-sort-asc" />;
        } else {
            return <i className="fa fa-sort-desc" />;
        }
    };

    /**
     * If we are sorting by this, return an icon to indicate direction
     * @returns {*}
     * @private
     */
    const _icon = () => {
        if (props.sort == props.sort_field) {
            return _sortingIcon();
        }

        return '';
    };

    return (
        <button
            className="btn btn-link tw-p-0 text-nowrap"
            style={{fontSize: '14px'}}
            onClick={handleClick}>
            {props.children} {_icon()}
        </button>
    );
};

Sort.displayName = 'Sort';

export default Sort;
